<template>
    <v-container>
        <v-card>
            <v-card-title class="justify-center primary" @click="mostrar()" style="cursor: pointer;">
                <v-toolbar-title id="titulocard">Llamadas</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon :color="'#FFFFFF'">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-card-title>
            <v-expand-transition>
                <div v-if="show">
                    <v-card-text style="margin-bottom: 4%;">
                        <v-row class="mt-1">
                            <v-col cols="12" md="6" sm="6" class="boton_Agregar">
                                <v-btn v-if="adjuntarArchivos == 1" tile @click="AdjuntarLlamada" color="success">
                                    <v-icon left>
                                        mdi-plus
                                    </v-icon>
                                    Agregar Llamada
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                                    :params="displayInputs" :order="[]" @apiDT="apiDT = $event"
                                    @Cancelar="CancelarShow">
                                </DataTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </div>
            </v-expand-transition>
        </v-card>
        <div v-if="dialog" id="cargando" style="z-index: 600;"
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div v-if="btnmostrar" class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <v-btn icon dark @click="dialog = false; Detener()" v-else>
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <h2 class="text-center text-white text-xl font-semibold">{{ Titulo }}</h2>
            <div class="py-3">
                <div id="escuchar" class="text-center">
                </div>
            </div>
        </div>
        <v-dialog v-model="dialogCalificar" scrollable persistent content-class="dialogShareClass"
            transition="dialog-bottom-transition">
            <template>
                <v-card>
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Calificar Llamada</v-toolbar-title>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="10">
                                    <span style="text-align: center;font-size: medium;">Tipo Llamada:</span>
                                    <p style="font-weight: 600; font-size: large;">{{ tipollamada }}</p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" col-md="8">
                                    <span style="text-align: center;font-size: medium;">Calificar Llamada:</span>
                                    <p style="font-weight: 600; font-size: large;">{{ docarchivo }}</p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" col-md="8" v-if="cargandoAudio" class="text-center">
                                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                </v-col>
                                <v-col cols="12" col-md="8">
                                    <div id="escucharModal" class="text-center">
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" col-md="8" class="text-center"
                                    style="display: grid; place-items: center;">
                                    <div class="text-center">
                                        <v-radio-group v-model="respuesta" row :error-messages="errorRadio">
                                            <v-radio label="No conforme" value="NC"></v-radio>
                                            <v-radio label="Conforme" value="C"></v-radio>
                                        </v-radio-group>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <span style="text-align: center;font-size: medium;">Motivo:</span>
                                    <multiselect style="display: block; margin-bottom: 10px" v-model="motivo"
                                        deselect-label="No se puede remover el valor seleccionado"
                                        selected-label="Seleccionado" select-label="Seleccione el motivo" track-by="ID"
                                        label="descripcion" placeholder="Seleccione una opción"
                                        :options="catalogoMotivos" :allow-empty="false" :disabled="disabledMotivo"
                                        @select="errormotivo = false">
                                    </multiselect>
                                    <span style="color: #FF5C93;font-size:11px" v-if="errormotivo">Campo
                                        requerido</span>
                                </v-col>
                            </v-row>

                            <v-row v-if="mostrarcomentario">
                                <v-col cols="12" col-md="8">
                                    <br />
                                    <span style="text-align: center;font-size: medium;">Comentarios:</span>
                                    <v-textarea :counter="400" :maxlength="$store.state.maxLengthComentarios"
                                        :rules="rulestextarea" outlined v-model="comentarios" name="input-7-4">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" :disabled="buttonCslificar"
                            @click="GuardarCalificacion()">Guardar</v-btn>
                        <v-btn color="error" :disabled="buttonCslificar" variant="text"
                            @click="CerrarModal()">Cancelar</v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
        <v-dialog transition="dialog-top-transition" persistent max-width="85vw" v-model="showTranscripcion"
            style="z-index: 10000;">
            <v-card style="max-height: 90vh; overflow-y: auto;">
                <v-card-title class="justify-center primary">
                    <v-toolbar-title id="titulocard">Transcripción Llamada</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="red accent-3" icon text @click="showTranscripcion = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text style="max-height: 600px; overflow-y: auto;">
                    <v-container v-if="!sintranscripcion">
                        <v-row v-for="(line, index) in transcripcion" :key="index" no-gutters>
                            <v-col :class="line.Speaker === 'A' ? 'text-right' : 'text-left'" cols="12">
                                <v-chip :color="line.color" :text-color="thema" class="ma-2 pa-2 d-inline-block"
                                    outlined
                                    style="white-space: normal; max-width: 50%; word-break: break-word; height: auto;">
                                    <div style="white-space: normal; word-break: break-word; line-height: 1.4;">
                                        <strong>{{ line.Speaker }}:</strong> {{ line.Text }}
                                    </div>
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-container v-else>
                        <v-row class="mt-2 py-5 align-center justify-center" offset-md="2">
                            <v-col cols="12" class="text-center">
                                <h5 style="text-align: center;">{{ this.transcripcion }}</h5>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import Archivos from '@/services/Archivos/Archivos.service.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Sistemas from "@/services/Sistemas/sistemas.service.js";
import Reporte from "@/services/ExpJur/ExpJur.service.js";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable
    },
    data: function () {
        return {
            urlListado: 'Archivos/ObtenerLlamadas',
            columns: [
                { name: 'Rutaarchivo', data: 'Rutaarchivo', title: 'Tipo' },
                { name: 'docarchivo', data: 'docarchivo', title: 'Archivo' },
                { name: 'docalta', data: 'docalta', title: 'Fecha' },
                { name: 'prclave', data: 'prclave', title: 'Usuario' },
                { name: "docid", data: "docid", title: "", formatter: [this, "Escuchar_Archivo"], orderable: false },
                { name: "ddocid", data: "docid", title: "", formatter: [this, "Descargar_Archivo"], orderable: false },
                { name: "ldocid", data: "docid", title: "", formatter: [this, "Generar_Enlace"], orderable: false},
                { name: "edocid", data: "docid", title: "", formatter: [this, "Eliminar_Archivo"], orderable: false },
                { name: "cdocid", data: "docid", title: "", formatter: [this, "Calificar_Llamada"], orderable: false },
                { name: "rcdocid", data: "docid", title: "", formatter: [this, "Restablecer_Calificacion"], orderable: false },
                { name: "docidT", data: "docid", title: "", formatter: [this, "TranscripcionesLlamadas"], orderable: false },
            ],
            show: false,
            displayInputs: {
                nrreporte: 0,
                svindice: 0
            },
            formatterActions: [
                { click: [this, "Escuchar"] },
                { click: [this, "DescargarArchivo"] },
                { click: [this, "EliminarArchivo"] },
                { click: [this, "CalificarLlamada"] },
                { click: [this, "RestablecerCalif"] },
                { click: [this, "VerTranscripcion"] },
                { click: [this, "HacerTranscripcion"] },
                { click: [this, "GenerarEnlace"]},
            ],
            apiDT: null,
            adjuntarArchivos: 0,
            dialog: false,
            Titulo: '',
            btnmostrar: false,
            permisoEliminar: false,
            datos: null,
            /* */
            permisocalificar: false,
            dialogCalificar: false,
            tipollamada: '',
            docarchivo: '',
            buttonCslificar: false,
            respuesta: null, errorRadio: '',
            mostrarcomentario: false,
            rulestextarea: [v => {
                if (v != null) {
                    if (v == null || v.trim().length === 0) {
                        return true; // No hay texto, por lo tanto, la validación es exitosa
                    }
                    // return 'Mínimo 12 Carácteres'
                    if (v.trim().length < 12) {
                        return 'Mínimo 12 caracteres'
                    }
                    else if (v.trim().length > 400) {
                        return 'Máximo 400 caracteres'
                    } else {
                        return true;
                    }
                }
            },],
            llamada: '',
            valid: true,
            catalogoMotivos: [],
            motivo: '',
            disabledMotivo: true,
            errormotivo: false,
            cargandoAudio: true,
            docid: '',
            permisorestablecer: false,
            comentarios: '',
            showTranscripcion: false,
            transcripcion: [],
            thema: '',
            iconoAlerta: null,
            tituloAlerta: null,
            mensajeAlerta: '',
            sintranscripcion: false,
            colores: ['#536DFE', '#3CD4A0', '#FF5C93', '#FFC260', '#9013FE'],
            speakerColores: {},
            loadingCallLink: false
        }
    },
    props: ['reporte', 'headers'],
    computed: {
        ...mapState([
            "domain",
            "informationPage",
            "paginacion",
            "permission",
            "user"
        ])
    },
    watch: {
        async 'respuesta'(val) {
            if (val != null) {
                this.errorRadio = '';
                this.mostrarcomentario = val == 'NC' ? true : false
                this.comentarios = val == 'C' ? '' : this.comentarios
                this.motivo = '';
                this.errormotivo = false
                await this.CatalogoConformeInconforme(val)
            }
        },
        async 'comentarios'(val) {
            if (val != '') {
                this.comentarios = val.trim()
                if (val.length == 0) {
                    this.comentarios = ''
                }
            }
        },
    },
    methods: {
        async obtenerPermisos() {
            let response = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '51,384,385');
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 51)//Permiso Eliminar
                        this.permisoEliminar = true;
                    if (permiso.peclave == 384)//Permiso Eliminar
                        this.permisocalificar = true;
                    if (permiso.peclave == 385)//Permiso restablecer
                        this.permisorestablecer = true;
                });
            }

        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        CancelarShow() {
            this.cargando = false;
        },
        Descargar_Archivo(datos) {
            return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small info dt-formatterAction" aria-haspopup="true" data-action="1" data-params="${datos.docid}" title="Descargar Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-download-outline theme--dark"></i></span></button></div>` : ``;
        },
        Escuchar_Archivo(datos) {
            return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small teal dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.docid}" title="Escuchar Llamada" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-play-circle-outline theme--dark"></i></span></button></div>` : ``;
        },
        Generar_Enlace(datos) {
            return datos.docid ? `<div><button type="button" :loading="${this.loadingCallLink}" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small teal dt-formatterAction" aria-haspopup="true" data-action="7" data-params='${datos.docid}' title="Generar Enlace" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-link theme--dark"></i></span></button></div>` : ``;
        },
        Eliminar_Archivo(datos) {
            if (this.permisoEliminar && [150, 151, 134, 135, 136, 137].includes(datos.doclave)) {
                return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small secondary dt-formatterAction" aria-haspopup="true" data-action="2" data-params="${datos.docid}" title="Eliminar Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-delete theme--dark"></i></span></button></div>` : ``;
            } else {
                return ``;
            }
        },
        Restablecer_Calificacion(datos) {
            if (this.permisorestablecer) {
                return datos.docestatus == 'C' || datos.docestatus == 'NC' ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small light-blue dt-formatterAction" aria-haspopup="true" data-action="4" data-params="${datos.docid}" title="Restablecer calificación" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-file-restore theme--dark"></i></span></button></div>` : ``;
            } else {
                return ``;
            }
        },
        Calificar_Llamada(datos) {
            if (this.permisocalificar) {
                return datos.docestatus != 'C' && datos.docestatus != 'NC' ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small light-blue dt-formatterAction" aria-haspopup="true" data-action="3" data-params="${datos.docid}" title="Calificar Llamada" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-file-star theme--dark"></i></span></button></div>` : ``;
            } else {
                return ``;
            }
        },
        TranscripcionesLlamadas(datos) {
            //5 ver y 6 hacer
            return datos.Haytranscripcion == 1 ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small cyan dt-formatterAction" aria-haspopup="true" data-action="5" data-params="${datos.docid}" title="Ver transcripción" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-comment-text theme--dark"></i></span></button></div>` : `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small indigo dt-formatterAction" aria-haspopup="true" data-action="6" data-params="${datos.docid}" title="Transcribir Llamada" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-transcribe theme--dark"></i></span></button></div>`;
        },
        ObtenerLlamadas() {
            Archivos.ObtenerLlamadas(this).then(data => {
                this.llamadas = data
                this.cargando = false;
            })
        },
        async GenerarLinkAcortado(val) {
            let uslogin = await MetodosGenerales.ObtenerUserName();
            this.$swal({
                title: 'Generando enlance, espere un momento por favor.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    this.btndis = true;
                    let response = await Sistemas.AgregarURLAcortada(1, val.trim(), uslogin);
                    if (response == null) {
                        navigator.clipboard.writeText(val);
                        this.$swal({
                            position: 'center',
                            icon: 'info',
                            title: 'Información',
                            html: `Está en localhost y no se puede generar el link acortado, pero se ha copiado sin acortar al portapapeles.<br/>${val}`,
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: "Copiar",
                            allowOutsideClick: false,
                            showDenyButton: true,
                            denyButtonText: "Aceptar",
                            denyButtonColor: "#536DFE",
                            preConfirm: async () => {
                                await navigator.clipboard.writeText(val)
                                this.$swal.update({ confirmButtonText: "Copiado"})
                                setTimeout(() => {
                                    this.$swal.update({ confirmButtonText: "Copiar"})
                                }, 1000)
                                return false
                            }
                        });
                    }
                    else if (response.error) {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Error',
                            text: response.msg,
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                        });
                    } 
                    else {
                        await navigator.clipboard.writeText(response.msg);
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Enlace generado exitosamente.',
                            html: `Se copio el siguiente enlace al portapapeles:<br/>${response.msg}`,
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Copiar',
                            allowOutsideClick: false,
                            showDenyButton: true,
                            denyButtonColor: '#536DFE',
                            denyButtonText: 'Aceptar',
                            preConfirm: async () => {
                                await navigator.clipboard.writeText(response.msg)
                                this.$swal.update({ confirmButtonText: "Copiado"})
                                setTimeout(() => {
                                    this.$swal.update({ confirmButtonText: "Copiar"})
                                }, 1000)
                                return false
                            }
                        })
                    }
                }
            })
        },
        async GenerarEnlace(params, datos, fila) {
            this.loadingCallLink = true
            var datosReporte = new FormData();
            datosReporte.append("nrreporte", this.datos.nrreporte);
            datosReporte.append("svindice", this.datos.svindice);
            let response = await Archivos.ObtenerDireccion(this.datos, datos.docid, 1);
            if (response.archivo != null){
                const fechaBase = await MetodosGenerales.obtenerFechaHoraBase()
                const linkExp = new Date().setDate(new Date(fechaBase.fechaHora).getDate() + 15)
                let sessionReporte = await MetodosGenerales.obtenerSessionReporte("reporte");
                const datosReporte = {
                    nrreporte: this.datos.nrreporte,
                    svindice: this.datos.svindice,
                    docid: datos.docid,
                    exp: linkExp,
                    tipo: datos.Rutaarchivo,
                    aiclave: sessionReporte.aiclave,
                    docarchivo: datos.docarchivo
                }
                let res = await MetodosGenerales.encryptData(datosReporte)
                let link = this.domain.domainNameWithHttp+'Llamadas?data='+res
                await this.GenerarLinkAcortado(link)
            }
            else
                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: 'Error',
                    text: "Lo sentimos, no se encontró el archivo solicitado.",
                    showConfirmButton: true,
                    confirmButtonColor: '#536DFE',
                    confirmButtonText: 'OK',
                    timer: 2500,
                })
            this.loadingCallLink = false
        },
        DescargarArchivo(params, datos, fila) {
            this.$swal({
                title: 'Descargando archivo, espere, por favor.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    var datosReporte = new FormData();
                    datosReporte.append("nrreporte", this.datos.nrreporte);
                    datosReporte.append("svindice", this.datos.svindice);
                    let response = await Archivos.ObtenerDireccion(this.datos, datos.docid, 1);
                    var formData = new FormData();
                    formData.append("lasitio", 'Prusia+');
                    formData.append("lomodulo", 'Llamadas');
                    formData.append("laaccion", "Descargó Audio");
                    formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
                    formData.append("lanombre", response.archivo);
                    formData.append("ladestinatario", "");
                    await Archivos.AlmacenarVisitas(formData);
                    if (response.archivo !== null) {
                        await MetodosGenerales.descargaArchivo(response.msg, datos.docarchivo + '.mp3', 'mp3');
                        this.$swal.close();
                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Error',
                            text: response.msg,
                            showConfirmButton: false,
                            timer: 2500
                        });
                    }
                },
            });
        },
        async Escuchar(params, datos, fila) {
            this.dialog = true;
            this.btnmostrar = true;
            var datosReporte = new FormData();
            datosReporte.append("nrreporte", this.datos.nrreporte);
            datosReporte.append("svindice", this.datos.svindice);
            let dir = await Archivos.ObtenerDireccion(this.datos, datos.docid, 1);
            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", "Llamadas");
            formData.append("laaccion", "Escuchó Audio");
            formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
            formData.append("lanombre", dir.archivo);
            formData.append("ladestinatario", "");
            await Archivos.AlmacenarVisitas(formData);
            if (dir.archivo !== null) {
                let audio = document.createElement('audio');
                audio.style.margin = '0 auto';
                audio.src = dir.watch;
                audio.controls = true;
                audio.autoplay = true;
                audio.controlsList = "nodownload";
                document.getElementById('escuchar').appendChild(audio);
                this.Titulo = datos.docarchivo;
            } else {
                this.$swal({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: dir.msg,
                    showConfirmButton: true,
                    confirmButtonColor: '#536DFE',
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false,
                });
                this.dialog = false;
            }
            this.btnmostrar = false;
        },
        Detener() {
            this.dialog = false;
            this.Titulo = '';
            document.querySelector("audio").remove();
        },
        async AdjuntarLlamada() {
            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            this.$router.push({ path: asistenciaurl + '/Archivos/AdjuntarLlamada' });


        },
        async obtenerEstadoReporte() {
            await Archivos.EstatusReporte(this, this.datos);
        },
        mostrar() {
            if (this.show == true) {
                this.show = false;
                this.llamadas = [];
            } else {
                this.show = true;
                this.cargando = true;
            }
        },
        async EliminarArchivo(params, datos, fila) {
            this.$swal({
                position: "center",
                icon: "info",
                text: "¿Está seguro que desea eliminar este archivo?",
                showCancelButton: true,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        title: 'Eliminando archivo, espere, por favor.',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: async () => {
                            this.$swal.showLoading();
                            let resp = await Archivos.EliminarArchivo(this.datos, datos.docid);
                            if (resp.error == false) {
                                var datosReporte = new FormData();
                                datosReporte.append("nrreporte", this.datos.nrreporte);
                                datosReporte.append("svindice", this.datos.svindice);
                                var formData = new FormData();
                                formData.append("lasitio", 'Prusia+');
                                formData.append("lomodulo", "Llamadas");
                                formData.append("laaccion", "Eliminó Audio");
                                formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
                                formData.append("lanombre", datos.docarchivo);
                                formData.append("ladestinatario", "");
                                Archivos.AlmacenarVisitas(formData);
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: resp.msg,
                                    showConfirmButton: true,
                                    confirmButtonColor: '#536DFE',
                                    confirmButtonText: 'Aceptar',
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {
                                    this.reloadTable();
                                });

                            } else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'warning',
                                    title: 'Error',
                                    text: resp.msg,
                                    showConfirmButton: false,
                                    timer: 2500
                                });
                            }
                        },
                    });
                }
            });
        },
        async CalificarLlamada(params, datos) {
            this.tipollamada = datos.Rutaarchivo;
            this.docarchivo = datos.docarchivo;
            this.llamada = datos;
            this.dialogCalificar = true;
            this.docid = datos.docid
            await this.EscucharAudioModal(datos);
        },
        CerrarModal() {
            const modal = document.getElementById("escucharModal");
            if (modal) {
                modal.innerHTML = '';
            }
            this.tipollamada = '';
            this.docarchivo = '';
            this.dialogCalificar = false;
            this.mostrarcomentario = false;
            this.respuesta = null;
            this.comentarios = '';
            this.errorRadio = '';
            this.disabledMotivo = true;
            this.errormotivo = false;
            this.motivo = '';
            this.cargandoAudio = true;
            this.buttonCslificar = false;
        },
        async GuardarCalificacion() {
            this.errorRadio = this.respuesta == null ? 'Campo requerido' : '';
            this.errormotivo = this.motivo == '' && this.respuesta == 'NC' ? true : false;
            if (this.$refs.form.validate() && this.errorRadio == '' && !this.errormotivo) {
                this.buttonCslificar = true;
                this.$swal({
                    position: 'center',
                    title: 'Guardando calificación, espere un momento....',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });
                this.motivo = this.motivo.ID != undefined ? this.motivo.ID : null;
                Archivos.CalificarLlamada(this, this.datos).then(resp => {
                    this.$swal.close();
                    if (resp.data.length == 0) {
                        this.disabled = true
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se guardó la calificación con éxito.',
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            timer: 2500,
                        }).then(async () => {
                            this.reloadTable();
                            this.CerrarModal();
                        })
                    } else {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: 'Ocurrió un error, al calificar la llamada, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                    }
                    this.buttonCslificar = false
                })
            }
        },
        async EscucharAudioModal(datos) {
            var datosReporte = new FormData();
            datosReporte.append("nrreporte", this.datos.nrreporte);
            datosReporte.append("svindice", this.datos.svindice);
            let dir = await Archivos.ObtenerDireccion(this.datos, datos.docid, 1);
            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", "Llamadas");
            formData.append("laaccion", "Escuchó Audio");
            formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
            formData.append("lanombre", dir.archivo);
            formData.append("ladestinatario", "");
            await Archivos.AlmacenarVisitas(formData);
            this.cargandoAudio = false;

            if (dir.archivo !== null) {
                let audio = document.createElement('audio');
                audio.style.margin = '0 auto';
                audio.src = dir.watch;
                audio.controls = true;
                audio.autoplay = false;
                audio.controlsList = "nodownload";
                document.getElementById('escucharModal').appendChild(audio);
                this.Titulo = datos.docarchivo;
            } else {
                this.$swal({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: dir.msg,
                    showConfirmButton: true,
                    confirmButtonColor: '#536DFE',
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false,
                });
            }
        },
        async CatalogoConformeInconforme(tipo) {
            let response = await Archivos.CatalogoConformeInconforme(tipo);
            this.catalogoMotivos = response
            this.disabledMotivo = false
        },
        RestablecerCalif(params, datos, fila) {
            this.$swal({
                title: `La llamada: ${datos.docarchivo} ya está calificada`,
                text: "¿Quiere restablecer la calificación?",
                type: 'warning',
                showCancelButton: true,
                allowOutsideClick: false,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.value) {
                    let respuesta = await Archivos.RestablecerCalificacionLlamada(this.datos, datos.docid)
                    if (respuesta.length == 0) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se restableció la calificación con éxito.',
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            timer: 2500,
                        }).then((result) => {
                            this.reloadTable();
                        })
                    }
                }
            })
        },
        async VerTranscripcion(params, datos) {
            let speakerColores = {};
            let colorIndex = 0;
            //Ir por la transcripcion
            let response = await Archivos.ObtenerTranscripcion(this, this.datos.nrreporte, this.datos.svindice, datos.docid);
            let trans = response[0].tratranscripcion;
            let aux = trans.replace(/\\r\\n/g, '').replace(/^'|'$/g, '');
            if (response[0].errorLlamada != 1) {
                this.transcripcion = JSON.parse(aux);
                this.transcripcion.forEach(speaker => {
                    const speakerId = speaker.Speaker;
                    if (!speakerColores[speakerId]) {
                        if (colorIndex < this.colores.length) {
                            speakerColores[speakerId] = this.colores[colorIndex];
                            colorIndex++;
                        } else {
                            // Generar un color aleatorio si se acabaron los predefinidos
                            speakerColores[speakerId] = '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
                        }
                    }
                    speaker.color = speakerColores[speakerId];
                });
                this.sintranscripcion = false;
            } else {
                this.transcripcion = aux
                this.sintranscripcion = true;
            }
            this.showTranscripcion = true;
            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", "Llamadas");
            formData.append("laaccion", "Vio Transcripción");
            formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
            formData.append("lanombre", datos.docarchivo);
            formData.append("ladestinatario", "");
            Archivos.AlmacenarVisitas(formData);
        },
        async HacerTranscripcion(params, datos) {
            this.$swal({
                position: "center",
                icon: "info",
                text: "¿Está seguro que desea transcribir esta llamada?",
                showCancelButton: true,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let dir = await Archivos.ObtenerDireccion(this.datos, datos.docid, 1);
                    if (dir.archivo !== null) {
                        this.$swal({
                            title: 'Transcribiendo llamada, espere, por favor.',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            didOpen: async () => {
                                this.$swal.showLoading();
                                let resp = await Archivos.TranscribirLlamada(this, this.datos, datos.docid);
                                if (resp && resp.error) {
                                    this.$swal({
                                        position: 'center',
                                        icon: 'info',
                                        title: 'Infomación',
                                        text: resp.msg,
                                        showConfirmButton: false,
                                        timer: 2500
                                    });
                                } else if (resp && resp.jobId) {
                                    await this.monitorProceso(resp.jobId);
                                    this.$swal({
                                        position: 'center',
                                        icon: this.iconoAlerta,
                                        title: this.tituloAlerta,
                                        text: this.mensajeAlerta,
                                        confirmButtonColor: '#536DFE',
                                        confirmButtonText: 'Aceptar',
                                        allowOutsideClick: false,
                                        timer: 2500,
                                    }).then(async () => {
                                        this.reloadTable();
                                    })

                                } else if (resp.error) {
                                    this.$swal({
                                        position: 'center',
                                        icon: 'warning',
                                        title: 'Error',
                                        text: resp.msg,
                                        showConfirmButton: false,
                                        timer: 2500
                                    });
                                }
                            },
                        });
                    } else {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: dir.msg,
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                        });
                    }
                }
            });
        },
        async monitorProceso(jobId) {
            return new Promise((resolve) => {
                const startTime = Date.now();
                let alertaMostrada = false;
                const interval = setInterval(async () => {
                    const estadoResponse = await Archivos.ObtenerEstadoProceso(this, jobId);
                    const tiempoTranscurrido = Date.now() - startTime;
                    // Mostrar advertencia si ya pasó cierto tiempo y no se ha completado
                    if (!alertaMostrada && tiempoTranscurrido > 2 * 60 * 1000) { // 2 minutos 2 * 60 * 1000
                        alertaMostrada = true;
                        this.$swal({
                            position: 'center',
                            icon: 'info',
                            title: 'La transcripción está tardando más de lo habitual',
                            text: 'Puede continuar trabajando mientras se completa.',
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: true
                        });
                    }
                    if (estadoResponse && estadoResponse.estado === "Completado") {
                        this.iconoAlerta = 'success';
                        this.tituloAlerta = 'Éxito';
                        this.mensajeAlerta = 'Se transcribió la llamada correctamente';
                        clearInterval(interval);
                        resolve();
                    }
                    if (estadoResponse && (estadoResponse.estado === "Error" || estadoResponse.estado === "Fallido")) {
                        this.iconoAlerta = 'warning';
                        this.tituloAlerta = 'Error';
                        this.mensajeAlerta = 'Ocurrió un error al transcribir la llamada. Intente nuevamente más tarde o contacte al soporte.';
                        clearInterval(interval);
                        resolve();
                    }

                }, 3000); // Polling cada 3 segundos
            });
        }

    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        this.obtenerEstadoReporte();
        await this.obtenerPermisos();
        await Archivos.EstatusReporte(this, this.datos);
        this.displayInputs = {
            nrreporte: this.datos.nrreporte,
            svindice: this.datos.svindice,
        };
        this.reloadTable();
    },
}
</script>